import { render, staticRenderFns } from "./WindowDamageSeverity.vue?vue&type=template&id=4d1ef8e2&scoped=true"
import script from "./WindowDamageSeverity.vue?vue&type=script&lang=ts"
export * from "./WindowDamageSeverity.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d1ef8e2",
  null
  
)

export default component.exports